/**
 * Route constants for standalone web navigation.
 * Used by App.jsx to bridge react-router and step-based navigation.
 */

// Step name → URL path
export const ROUTE_MAP = {
  home: '/',
  catalog: '/catalog',
  cart: '/cart',
  profile: '/profile',
  login: '/login',
  privacy: '/privacy',
  payment_status: '/payment/status',
};

// URL path → step name
export const PATH_TO_STEP = Object.fromEntries(
  Object.entries(ROUTE_MAP).map(([step, path]) => [path, step])
);
